export default __webpack_public_path__ + "static/media/cash.1a868f5e.svg";